































import Vue from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import SpeechBubble from "@/components/Atoms/SpeechBubble/index.vue";
import TextField from "@/components/Atoms/Forms/TextField/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";
import { EditPlanViewEvent } from "./types";
import { KEYCODE } from "@/constants/event";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Heading,
    SpeechBubble,
    TextField,
    Caption
  },
  props: {
    planName: {
      type: String,
      required: true
    },
    errorMessage: {
      type: String,
      default: ""
    }
  },
  computed: {
    isInvalid() {
      return this.planName === "";
    }
  },
  mounted() {
    window.addEventListener("keyup", this.handlePressKey);
  },
  methods: {
    handleProjectNameBlur() {
      this.$emit("change", {
        willUpdateDatabase: true,
        planName: this.planName
      });
    },
    handleProjectNameChange(value) {
      this.$emit("change", {
        willUpdateDatabase: false,
        planName: value
      } as EditPlanViewEvent);
    },
    pressKeyWithSubmit() {
      this.handleProjectNameBlur();
      this.$emit("pressKey");
    },
    handlePressKey(event) {
      if (event.keyCode !== KEYCODE.ESC) {
        return;
      }
      this.pressKeyWithSubmit();
    },
    handlePressEnter(event) {
      if (event.keyCode !== KEYCODE.ENTER) {
        return;
      }
      this.pressKeyWithSubmit();
    }
  }
});
